import React, { useState } from 'react';
import { View, StyleSheet, Platform, Text } from 'react-native';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import AdminMenuScreen from './AdminMenuScreen';
import AdminDashboard from './AdminDashboard';
import UserManagementScreen from './UserManagementScreen';
import VendorsScreen from './VendorsScreen';
import VendorTypesScreen from './VendorTypesScreen';
import { colors } from '../../constants/theme';

type AdminView = 'menu' | 'userManagement' | 'reviewTemplates' | 'vendors' | 'vendorTypes';

export const AdminScreen: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const [currentView, setCurrentView] = useState<AdminView>('menu');
  
  // Check if user is admin
  const isAdmin = user?.role === 'admin';
  
  // If not admin, show access denied
  if (!isAdmin) {
    return (
      <View testID="admin-access-denied" style={styles.accessDenied}>
        <Text style={styles.accessDeniedText}>
          Admin access required. Please contact an administrator.
        </Text>
      </View>
    );
  }
  
  // Handle back navigation
  const handleBack = () => {
    setCurrentView('menu');
  };
  
  // Render current view
  switch (currentView) {
    case 'userManagement':
      return (
        <UserManagementScreen onBack={handleBack} />
      );
      
    case 'reviewTemplates':
      return (
        <AdminDashboard onBack={handleBack} />
      );
      
    case 'vendors':
      return (
        <VendorsScreen onBack={handleBack} />
      );
      
    case 'vendorTypes':
      return (
        <VendorTypesScreen onBack={handleBack} />
      );
      
    case 'menu':
    default:
      return (
        <AdminMenuScreen
          onNavigateToUserManagement={() => setCurrentView('userManagement')}
          onNavigateToReviewTemplates={() => setCurrentView('reviewTemplates')}
          onNavigateToVendors={() => setCurrentView('vendors')}
          onNavigateToVendorTypes={() => setCurrentView('vendorTypes')}
        />
      );
  }
};

const styles = StyleSheet.create({
  accessDenied: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
    backgroundColor: colors.background,
  },
  accessDeniedText: {
    fontSize: 16,
    color: colors.textSecondary,
    textAlign: 'center',
    lineHeight: 24,
  },
});

export default AdminScreen;
